import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { Partner, partnersService } from '@aslanpay/portal-common-lib';

interface DeletePartnerRequest {
  id: string;
}

const useDeletePartner = ({
  onSuccess,
  onError,
}: UseMutationOptions<Partner, Error, DeletePartnerRequest>) => {
  return useMutation<Partner, Error, DeletePartnerRequest>(
    ({ id }: DeletePartnerRequest) => partnersService.deletePartner(id),
    { onSuccess, onError }
  );
};

export default useDeletePartner;
